enum DesignSourceEnum {
	clipboard = 'clipboard',
	designSearch = 'design_search',
	email = 'email',
	enterCode = 'enter_code',
	gallery = 'gallery',
	imageDeeplink = 'image_deeplink',
	iSell = 'i_sell', // TODO: Deprecate in favour of salesSystem
	planningSupportTool = 'planning_support_tool',
	qr = 'qr',
	recommendation = 'recommendation',
	resumeLastDesign = 'resume_last_design',
	retailerSystem = 'retailer_system',
	salesSystem = 'sales_system',
	searchBar = 'search_bar',
	skytta = 'skytta',
	sms = 'sms',
	space = 'space',
	spr = 'spr',
	profile = 'profile',
	storageGuide = 'storage_guide',
	startFromSaved = 'start_from_saved',
	startFromScratch = 'start_from_scratch',
	startFromTemplate = 'start_from_template',
	unknown = 'unknown'
}

export default DesignSourceEnum;
